import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../utils/Style/component/skeleton.scss';

function PaginationSkeleton() {
    const divs = Array.from({ length: 4 }, (_, index) => (
        <div className="ms-1 col-2" key={index}>
            <Skeleton key={index} variant="circular" className="circular-skeleton"/>
        </div>
    ));

    return (
        <div className="row">
            <div className="col-9"></div>
            <div className="row col-3">{divs}</div>
        </div>
    );
}

export default PaginationSkeleton;